import Store from '../loadables/SalesChannel';
export default [{path: '/stores', component: Store, scope: 'sales_channels.view'}];
